__turbopack_context__.v({
  "container": "Banner-module__FO3zUq__container",
  "firstSlot": "Banner-module__FO3zUq__firstSlot",
  "icon": "Banner-module__FO3zUq__icon",
  "secondSlot": "Banner-module__FO3zUq__secondSlot",
  "slot": "Banner-module__FO3zUq__slot",
  "titleBarContent": "Banner-module__FO3zUq__titleBarContent",
});
